import { Collapse } from "@mantine/core";

import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import EmojiModal        from "_components/features/chat/userInteractions/emojiModal";

import useStyles from "./styles";

const EmojiDrawer = ( { displayEmoji, handleEmojiSelect } ) => {
	const { classes } = useStyles ( { displayEmoji }, { name: "emojiDrawer" } );

	return (
		<BackgroundWrapper
			className = { classes.emojiModalParent }
			type      = "secondary"
		>
			<Collapse
				in                       = { displayEmoji }
				transitionTimingFunction = { "ease" }
			>
				<EmojiModal handleEmojiSelect = { handleEmojiSelect } />
			</Collapse>
		</BackgroundWrapper>
	);
};

export default EmojiDrawer;
